import TheBanner from 'layout/TheBanner/TheBanner'
import TheFooter from 'layout/TheFooter'
import TheHeader from 'layout/TheHeader'
import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import routes from 'routes'

const TheRoutes = () => {
  return (
    <BrowserRouter>
      <TheHeader />
      <main>
        <TheBanner />
        <Routes>
          {routes.map((elm) => {
            return <Route key={elm.path} path={elm.path} element={elm.element} />
          })}
        </Routes>
      </main>
      <TheFooter />
    </BrowserRouter>
  )
}

export default TheRoutes
